export default "__VITE_ASSET__BmmWj4bP__"